import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Gas & Charging",
    keywords: [
      "shell oil",
      "shell",
      "bp#",
      "bp ",
      "speedway",
      "loves",
      "road ranger",
      "marathon",
      "exxon",
      "mobil ",  // Trailing space to avoid matching "mobile" in parking apps
      "chevron",
      "sunoco",
      "texaco",
      "gulf oil",
      "phillips 66",
      "costco gas",
      "sams club gas",
      "sam's club gas",
      "circle k",
      "7-eleven",
      "wawa",
      "sheetz",
      "pilot",
      "flying j",
      "tesla supercharger",
      "electrify america",
      "evgo",
      "chargepoint",
    ],
  },
  {
    category: "Auto & Vehicle",
    keywords: [
      "jiffy lube",
      "autozone",
      "advance auto",
      "o'reilly auto",
      "pep boys",
      "firestone",
      "goodyear",
      "valvoline",
      "midas",
      "meineke",
      "mavis",
      "discount tire",
      "big o tires",
      "secretary of",
      "veh reg",
      "reg renew",
      "vehicle registration",
      "tesla",
      "il tollway",
      "ilsos",
      "carmax",
      "carvana",
      "vroom",
      "auto repair",
      "mechanic",
      "body shop",
      "collision",
      "tire",
      "oil change",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  // Gas Stations
  { keyword: "shell", displayName: "Shell" },
  { keyword: "bp#", displayName: "BP" },
  { keyword: "bp ", displayName: "BP" },
  { keyword: "speedway", displayName: "Speedway" },
  { keyword: "marathon", displayName: "Marathon" },
  { keyword: "exxon", displayName: "Exxon" },
  { keyword: "mobil", displayName: "Mobil" },
  { keyword: "chevron", displayName: "Chevron" },
  { keyword: "circle k", displayName: "Circle K" },
  { keyword: "costco gas", displayName: "Costco Gas" },
  { keyword: "tesla supercharger", displayName: "Tesla Supercharger" },

  // Auto Services
  { keyword: "jiffy lube", displayName: "Jiffy Lube" },
  { keyword: "autozone", displayName: "AutoZone" },
  { keyword: "advance auto", displayName: "Advance Auto Parts" },
  { keyword: "o'reilly auto", displayName: "O'Reilly Auto Parts" },
  { keyword: "firestone", displayName: "Firestone" },
  { keyword: "goodyear", displayName: "Goodyear" },
  { keyword: "valvoline", displayName: "Valvoline" },
  { keyword: "carmax", displayName: "CarMax" },
  { keyword: "carvana", displayName: "Carvana" },
];
